import { Loader2 } from 'lucide-react'

interface GenerationProgressProps {
  progress: {
    status: string
    message?: string
    percentage?: number
  }
}

export function GenerationProgress({ progress }: GenerationProgressProps) {
  return (
    <div className="bg-[#161b22] rounded-xl p-6 border border-cyan-900/30">
      <div className="flex items-center space-x-4">
        <Loader2 className="w-6 h-6 text-cyan-400 animate-spin" />
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-white">生成中...</h3>
          <p className="text-gray-400 mt-1">
            {progress.message || '正在处理您的请求，请稍候'}
          </p>
          {progress.percentage && (
            <div className="mt-3">
              <div className="w-full bg-gray-700 rounded-full h-2">
                <div
                  className="bg-gradient-to-r from-cyan-500 to-blue-500 h-2 rounded-full transition-all duration-300"
                  style={{ width: `${progress.percentage}%` }}
                ></div>
              </div>
              <p className="text-xs text-gray-400 mt-1">{progress.percentage}%</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
